// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"on_a bhg_qr bhg_a bhg_w","FaqAskQuestion__outdated":"on_b bhg_vp bhg_xe"};